// extracted by mini-css-extract-plugin
export default {"contenedorForm":"GenerarUsuariosComponent_contenedorForm__RTexd","tituloForm":"GenerarUsuariosComponent_tituloForm__fIMql","error":"GenerarUsuariosComponent_error__3HAj5"};